import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { Subject } from 'rxjs';
import { ChannelSocketCommands } from 'ops/common/io-event/websocket-message';
import { Channel } from 'ops/common/models/channel';

@Injectable({ providedIn: 'root' })
export class ChannelSocketService {
    updateChannelList$: Subject<void> = new Subject<void>();
    updateChannel$: Subject<Channel> = new Subject<Channel>();

    constructor(private socketService: SocketMiddlewareService) {
        this.channelListUpdated();
        this.channeUpdated();
    }

    updateListSubject(): Subject<void> {
        return this.updateChannelList$;
    }

    updateChannelSubject(): Subject<Channel> {
        return this.updateChannel$;
    }

    channelListUpdated() {
        return this.socketService
            .receiveMessageObserver(ChannelSocketCommands.LIST_UPDATED)
            .subscribe(() => this.updateChannelList$.next());
    }

    channeUpdated() {
        return this.socketService
            .receiveMessageObserver(ChannelSocketCommands.CHANNEL_UPDATED)
            .subscribe((channel) => this.updateChannel$.next(channel));
    }
}
